import { useMemo } from "react";
import { Outlet } from "react-router-dom";

import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";

import { AppSidebar } from "./AppSidebar";
import { RouteBreadcrumbs } from "./Breadbrumbs";

function persistedSidebarOpen() {
    const cookieValue = document.cookie
        .split(";")
        .find(c => c.startsWith("sidebar:state="))
        ?.split("=", 2)[1];
    return cookieValue ? cookieValue === "true" : undefined;
}

export default function AppLayout() {
    const initialSidebarOpen = useMemo(() => persistedSidebarOpen() ?? true, []);

    return (
        <SidebarProvider defaultOpen={initialSidebarOpen}>
            <AppSidebar />
            <div className="flex flex-1 flex-col">
                <aside className="flex flex-grow-0 flex-row items-center">
                    <div className="mx-4 my-6 md:hidden">
                        <SidebarTrigger />
                    </div>
                    <RouteBreadcrumbs />
                </aside>
                <main className="flex-1">
                    <Outlet />
                </main>
            </div>
        </SidebarProvider>
    );
}
